import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import { message as AntMessage } from 'antd';
import { createGlobalStyle } from 'styled-components';
export var GlobalStyle = createGlobalStyle(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  .ant-message  {\n    top: ", ";\n  }\n  .ant-message > div > .ant-message-notice  {\n    text-align: right;\n    padding: ", ";\n  }\n  .ant-message > div > .ant-message-notice > .ant-message-notice-content {\n    margin-right: ", ";\n    background-color: black;\n    color: white;\n  }\n  .ant-message > div > .ant-message-notice > .ant-message-notice-content > .ant-message-loading > .anticon {\n    color: white;\n  }\n"])), function (props) {
  return props.isMobile ? '1.143rem' : '3rem';
}, function (props) {
  return props.isMobile ? '0' : '0.571rem';
}, function (props) {
  return props.isMobile ? '0.857rem' : '5rem';
});
var Message = Object.assign(AntMessage, {
  GlobalStyle: GlobalStyle
});
export default Message;